import api from './axios';

export const contactAPI = {
  /** GET /api/admin/contact-settings */
  get: () => api.get('/admin/contact-settings'),

  /** PUT /api/admin/contact-settings */
  update: (payload) => api.put('/admin/contact-settings', payload),
};
